const GROUPS_FETCH_REQUEST = 'groups_fetch_request'
const GROUPS_FETCH_SUCCESS = 'groups_fetch_success'
const GROUPS_FETCH_ERROR = 'groups_fetch_error'

const GROUPS_DELETE_REQUEST = 'groups_delete_request'
const GROUPS_DELETE_FETCH_SUCCESS = 'groups_delete_fetch_success'
const GROUPS_DELETE_FETCH_ERROR = 'groups_delete_fetch_error'

const GROUPS_CREATE_FETCH_REQUEST = 'groups_create_fetch_request'
const GROUPS_CREATE_FETCH_SUCCESS = 'groups_create_fetch_success'
const GROUPS_CREATE_REQUEST_ERROR = 'groups_create_request_error'

const GET_GROUP_FETCH_SUCCESS = 'get_group_fetch_success'
const GROUP_RENAME_FETCH_SUCCESS = 'group_rename_fetch_success'
const GROUP_RENAME_FETCH_REQUEST = 'group_rename_fetch_request'

const ADD_SUBGROUP_FETCH_REQUEST = 'add_subgroup_fetch_request'
const ADD_SUBGROUP_FETCH_SUCCESS = 'add_subgroup_fetch_success'

const RENAME_SUBGROUP_FETCH_REQUEST = 'rename_subgroup_fetch_request'
const RENAME_SUBGROUP_FETCH_SUCCESS = 'rename_subgroup_fetch_success'

const DELETE_SUBGROUP_REQUEST = 'delete_subgroup_request'
const DELETE_GROUP_REQUEST = 'delete_group_request'

const ATTACH_SUBSCRIBERS_REQUEST = 'attach_subscribers_request'
const ATTACH_SUBSCRIBERS_REQUEST_SUCCESS = 'attach_subscribers_request_success'
const ATTACH_SUBSCRIBERS_REQUEST_ERROR = 'attach_subscribers_request_error'

const GET_SUBSCRIBERS_REQUEST = 'get_members_subscribers'

const DETACH_SUBSCRIBERS_REQUEST = 'detach_subscribers_request'
const DETACH_SUBSCRIBERS_REQUEST_SUCCESS = 'detach_subscribers_request_success'
const DETACH_SUBSCRIBERS_REQUEST_ERROR = 'detach_subscribers_request_error'

const DETACH_SUBSCRIBERS_GROUP_REQUEST = 'detach_subscribers_group_request'

const SEARCH_GROUP = 'search_group'

const EDIT_SUBSCRIBERS_REQUEST = 'edit_subscribers_request'

export {
  GROUPS_FETCH_REQUEST,
  GROUPS_FETCH_SUCCESS,
  GROUPS_FETCH_ERROR,
  GROUPS_DELETE_REQUEST,
  GROUPS_DELETE_FETCH_SUCCESS,
  GROUPS_DELETE_FETCH_ERROR,
  GROUPS_CREATE_FETCH_REQUEST,
  GROUPS_CREATE_FETCH_SUCCESS,
  GROUPS_CREATE_REQUEST_ERROR,
  GET_GROUP_FETCH_SUCCESS,
  GROUP_RENAME_FETCH_SUCCESS,
  GROUP_RENAME_FETCH_REQUEST,
  ADD_SUBGROUP_FETCH_REQUEST,
  ADD_SUBGROUP_FETCH_SUCCESS,
  RENAME_SUBGROUP_FETCH_REQUEST,
  RENAME_SUBGROUP_FETCH_SUCCESS,
  DELETE_SUBGROUP_REQUEST,
  DELETE_GROUP_REQUEST,
  ATTACH_SUBSCRIBERS_REQUEST,
  ATTACH_SUBSCRIBERS_REQUEST_SUCCESS,
  ATTACH_SUBSCRIBERS_REQUEST_ERROR,
  GET_SUBSCRIBERS_REQUEST,
  DETACH_SUBSCRIBERS_REQUEST,
  DETACH_SUBSCRIBERS_REQUEST_SUCCESS,
  DETACH_SUBSCRIBERS_REQUEST_ERROR,
  SEARCH_GROUP,
  DETACH_SUBSCRIBERS_GROUP_REQUEST,
  EDIT_SUBSCRIBERS_REQUEST,
}
